import { render, staticRenderFns } from "./UsersGroupForm.vue?vue&type=template&id=2bb87205&"
import script from "./UsersGroupForm.vue?vue&type=script&lang=js&"
export * from "./UsersGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports